import { h } from "@stencil/core";

export const GaugeChartArc = (props) => (
    <path
        class={{
            "uic-gauge-chart__arc": props.a,
            [`uic-gauge-chart__arc--${props.arcKey.toLowerCase()}`]: true,
            [`${props.additionalCssClass}`]: props.additionalCssClass,
        }}
        d={
            props.pathInterpolator
                ? props.pathInterpolator(props.arcFn, props.t)
                : props.arcFn(props.value)
        }
    ></path>
);
